import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { Button } from '@/shared/ui';

interface SaveErrorNoticeProps {
  readonly message: string;
  /** 경합(409)처럼 다시 저장하면 풀릴 수 있을 때만 준다. */
  readonly onRetry: (() => void) | null;
  /** 인증 전 계정의 거절이면 온보딩 주소를 준다 — 다시 시도 대신 인증을 마치러 가는 링크를 보인다. */
  readonly onboardingHref?: string | null;
}

/** 저장 오류 줄(§6-5). 경합이면 '다시 시도' 버튼을, 인증 전 거절이면 온보딩 링크를 함께 보인다. */
export const SaveErrorNotice = ({
  message,
  onRetry,
  onboardingHref = null,
}: SaveErrorNoticeProps): ReactElement => (
  <div
    role="alert"
    className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-destructive"
  >
    <p>{message}</p>
    {onRetry !== null && (
      <Button type="button" size="sm" variant="outline" onClick={onRetry}>
        다시 시도
      </Button>
    )}
    {onboardingHref !== null && (
      <Link
        to={onboardingHref}
        className="font-semibold text-foreground underline underline-offset-4 hover:no-underline"
      >
        인증 완료하러 가기
      </Link>
    )}
  </div>
);
